import React from 'react';
import PropTypes from 'prop-types';

export function PaginationButton({
  'aria-disabled': ariaDisabled = null,
  children = null,
  disabled = false,
  to: dataHref = null,
  ...rest
}) {
  const isDisabled = disabled || ariaDisabled === true || ariaDisabled === 'true';

  return (
    // TODO: If button pagination becomes the default, remove data-href and let
    // Pagination pass page numbers to callbacks.
    <button
      type="button"
      {...(!isDisabled && dataHref ? { 'data-href': dataHref } : {})}
      {...rest}
      disabled={isDisabled}
    >
      {children}
    </button>
  );
}

PaginationButton.propTypes = {
  'aria-disabled': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  rel: PropTypes.string,
  role: PropTypes.string,
  to: PropTypes.string,
};
